export const networks = [
  {
    chainId: 'pisco-1',
    faucetUrl: 'https://pisco-faucet.terra.dev/claim',
  },
];
